import React, { useEffect } from 'react';
import { useFramework } from '../../hooks';

interface IProp{
  header?: React.ReactNode,
  visibleHeader?: boolean,
  quickMenu?: React.ReactNode,
  footer?: React.ReactNode,
  visibleFooter?: boolean,
  siderBar?: React.ReactNode,
  visibleSiderBar?: boolean,
  className?: string,
  headerClassName?: string,
  visibleCity?: boolean,
  visibleSimpleHeader?: ''
}

const FrameworkH5Helmet: React.FC<IProp> = ({
  header,
  visibleHeader=true,
  visibleSimpleHeader =false,
  quickMenu,
  footer,
  visibleFooter=true,
  siderBar,
  visibleSiderBar=true,
  className,
  headerClassName,
  visibleCity=false
}) => {
  const {
    actions: {
      dispatch,
      initFramework
    }
  } = useFramework();

  useEffect(() => {
    dispatch({
      payload: {
        header,
        visibleHeader,
        visibleSimpleHeader,
        quickMenu,
        footer,
        visibleFooter,
        siderBar,
        visibleSiderBar,
        className,
        headerClassName,
        visibleCity
      }
    });
  }, [dispatch, header, footer, siderBar, quickMenu,
    visibleHeader,visibleSimpleHeader, visibleFooter, visibleSiderBar,
    className, headerClassName, visibleCity
  ]);

  useEffect(() => {
    /**
     * 在一个没有任何依赖的useEffect中，保证只执行一次
     */
    return initFramework;
  }, [])

  return null
}

export default FrameworkH5Helmet
